export default "__VITE_ASSET__a8491f9b__"